jQuery($ => {

  if($('.m-reviews')[0]){
    $('.m-reviews__list').slick({
      slidesToShow: 1,
      slidesToScroll: 1, 
      arrows: true, 
      dots: false, 
      infinite: true,
      prevArrow: $('.m-reviews__arrow--prev'),
      nextArrow: $('.m-reviews__arrow--next'),
    });
  }

});